import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, TextField, Select, MenuItem } from "@mui/material";

const AddCommunityGroup = () => {
  const navigate = useNavigate();

  const [groupName, setGroupName] = useState("");
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("default");
  const [status, setStatus] = useState(true);
  const [members, setMembers] = useState("");

  // Report fields
  const [reportedBy, setReportedBy] = useState("");
  const [reportReason, setReportReason] = useState("default");
  const [reportDate, setReportDate] = useState("");
  const [reportStatus, setReportStatus] = useState("Pending");

  // Created date field
  const [createdDate, setCreatedDate] = useState("");

  return (
    <>
      <div className="main_title">
        <h1>Add Community Group</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
          <button onClick={() => navigate("/manage-community")}>
            Manage Community Groups
          </button>
          - Add Group
        </p>
      </div>

      <div className="cards">
        <div className="form">
          <div className="gap_p">
            {/* Group Name */}
            <div className="control_group w_33">
              <label>Group Name*</label>
              <TextField
                placeholder="Enter Group Name"
                fullWidth
                value={groupName}
                onChange={(e) => setGroupName(e.target.value)}
              />
            </div>

            {/* Description */}
            <div className="control_group w_100">
              <label>Description*</label>
              <TextField
                placeholder="Enter Description"
                fullWidth
                multiline
                rows={3}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            {/* Category */}
            <div className="control_group w_33">
              <label>Category</label>
              <Select
                fullWidth
                value={category}
                onChange={(e) => setCategory(e.target.value)}
              >
                <MenuItem disabled value="default">
                  Select Category
                </MenuItem>
                <MenuItem value="Fitness">Fitness</MenuItem>
                <MenuItem value="Nutrition">Nutrition</MenuItem>
                <MenuItem value="Wellness">Wellness</MenuItem>
              </Select>
            </div>

            {/* Member Count */}
            <div className="control_group w_33">
              <label>Members Count*</label>
              <TextField
                placeholder="Enter Member Count"
                fullWidth
                value={members}
                onChange={(e) => setMembers(e.target.value)}
              />
            </div>

            {/* Created Date */}
            <div className="control_group w_33">
              <label>Created Date*</label>
              <TextField
                type="date"
                fullWidth
                value={createdDate}
                onChange={(e) => setCreatedDate(e.target.value)}
              />
            </div>

            {/* Status Toggle */}
            <div className="control_group w_33">
              <label>Status</label>
              <div style={{ marginTop: "8px" }}>
                <input
                  type="checkbox"
                  checked={status}
                  onChange={() => setStatus(!status)}
                />{" "}
                Active
              </div>
            </div>

            {/* Reported By */}
            <div className="control_group w_33">
              <label>Reported By</label>
              <TextField
                placeholder="Enter Username"
                fullWidth
                value={reportedBy}
                onChange={(e) => setReportedBy(e.target.value)}
              />
            </div>

            {/* Report Reason */}
            <div className="control_group w_33">
              <label>Report Reason</label>
              <Select
                fullWidth
                value={reportReason}
                onChange={(e) => setReportReason(e.target.value)}
              >
                <MenuItem disabled value="default">
                  Select Reason
                </MenuItem>
                <MenuItem value="Spam">Spam</MenuItem>
                <MenuItem value="Offensive">Offensive</MenuItem>
                <MenuItem value="Harassment">Harassment</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </Select>
            </div>

            {/* Report Date */}
            <div className="control_group w_33">
              <label>Report Date</label>
              <TextField
                type="date"
                fullWidth
                value={reportDate}
                onChange={(e) => setReportDate(e.target.value)}
              />
            </div>

            {/* Report Status */}
            <div className="control_group w_33">
              <label>Report Status</label>
              <Select
                fullWidth
                value={reportStatus}
                onChange={(e) => setReportStatus(e.target.value)}
              >
                <MenuItem value="Pending">Pending</MenuItem>
                <MenuItem value="Reviewed">Reviewed</MenuItem>
                <MenuItem value="Resolved">Resolved</MenuItem>
              </Select>
            </div>
          </div>

          {/* Save Button */}
          <div className="form_btn">
            <Button className="btn btn_primary">Save</Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCommunityGroup;
